// extracted by mini-css-extract-plugin
export default {"title":"AreYouSureModal_title__oWZq6","content":"AreYouSureModal_content__u9npr","message":"AreYouSureModal_message__X7MbZ","btnsBox":"AreYouSureModal_btnsBox__NoOqr"};